import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import i18n from './i18n';
import { getLocaleFromPathname } from './routing';

const LocaleSync: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const locale = getLocaleFromPathname(location.pathname);
    if (i18n.language !== locale) {
      void i18n.changeLanguage(locale);
    }
    if (typeof document !== 'undefined') {
      document.documentElement.lang = locale === 'pt' ? 'pt-BR' : locale === 'en' ? 'en' : 'es';
    }
  }, [location.pathname]);

  return <>{children}</>;
};

export default LocaleSync;
